<template>
  <div
    :id="id"
    :class="{
      'roomie-card--dark': dark,
      'roomie-card--clickable': clickable
    }"
    class="roomie-card"
    @click="handleClick">
    <figure v-if="!$slots.figure">
      <img
        :src="src"
        :alt="alt"
        loading="lazy">
    </figure>

    <div
      v-else>
      <slot name="figure" />
    </div>

    <div
      v-if="$slots['top-actions']"
      class="roomie-card__top-actions">
      <slot name="top-actions" />
    </div>

    <main>
      <template v-if="!$slots.content">
        <div
          v-if="tags"
          class="roomie-card__tags">
          <RoomieTag
            v-for="(tag, index) in tags"
            :id="`tag-${index}`"
            :key="`tag-${index}`"
            :label="tag" />
        </div>

        <p
          v-if="label"
          class="roomie-card__label">
          {{ label }}
        </p>

        <p
          v-if="title"
          class="roomie-card__title">
          {{ title }}
        </p>

        <p
          v-if="description"
          class="roomie-card__description">
          {{ description }}
        </p>

        <p
          v-if="suportText"
          class="roomie-card__suport-text">
          {{ suportText }}
        </p>

        <p
          v-if="mainText"
          class="roomie-card__main-text">
          {{ mainText }}
        </p>

        <div class="roomie-card__ctas">
          <RoomieButton
            v-if="cta"
            id="card-button"
            size="sm"
            @click="$emit('click:cta')">
            {{ cta }}
          </RoomieButton>
        </div>
      </template>

      <slot
        v-else
        name="content" />
    </main>
  </div>
</template>

<script>
import RoomieButton from '../RoomieButton/index.vue'
import RoomieTag from '../RoomieTag/index.vue'

export default {
  name: 'RoomieCard',
  components: {
    RoomieButton,
    RoomieTag
  },
  props: {
    alt: {
      type: String,
      required: true
    },
    clickable: {
      type: Boolean,
      default: false
    },
    cta: {
      type: String,
      default: ''
    },
    dark: {
      type: Boolean,
      default: false
    },
    description: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      required: true
    },
    label: {
      type: String,
      default: ''
    },
    mainText: {
      type: String,
      default: ''
    },
    src: {
      type: String,
      required: true
    },
    suportText: {
      type: String,
      default: ''
    },
    tags: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: ''
    }
  },
  emits: ['click', 'click:cta'],
  methods: {
    handleClick (event) {
      const isClickableTag = ['BUTTON', 'A'].includes(event.target?.tagName)
      if (this.clickable && !isClickableTag) {
        this.$emit('click', event)
      }
    }
  }
}
</script>

<style src='./_index.scss' lang='scss'/>
